export default __webpack_public_path__ + "static/landing-section-3-img-5-2ebcd06783fd70386dcb17b1b3b3daa2.png";